import axios from 'axios';
import {responseHandler} from './responseHandler';
import {apiServiceUrl} from "./skeletonSaga";

export const skeletonDelete = (
    action: string,
    endpoint: string
): Promise<unknown> => {
    const token = localStorage.getItem('sessionToken');
    const headers = {"Authorization": `Bearer ${token}`};
    return axios
        .delete(apiServiceUrl + endpoint + '/' + action, {headers: headers})
        .then(response => responseHandler(response))
        .catch(function (error) {
            throw error;
        });
};
